import React, { Component } from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';

import axios from 'axios';
import qs from 'qs';

import InputText from '../../components/form/input/text';
import InputCheckbox from '../../components/form/input/checkbox';
import InputSubmit from '../../components/form/input/submit';
import ContentBlock from '../../components/account/block/content';
import {
	formIsValid,
	VALIDATE_CHECKED,
	VALIDATE_EMAIL,
	VALIDATE_MIN_LENGTH,
	VALIDATE_EQUALS_FIELD,
} from '../../components/form/validate';
import Spinner from '../../components/svg/spinner';

import { redirectToPathIf } from '../../utils/authorization';
import baseUrl from '../../utils/baseUrl';
import { accountRoute, genericRoute } from '../../routes';

import FBAuth from '../../utils/social/fb';
import GoogleAuth from '../../utils/social/google';
import TwitterAuth from '../../utils/social/twitter';

import connect from '../../utils/connect';
import translate from '../../utils/translate';

import { dispatchError } from '../../actions/errors';

//import css from './login.scss';

class AccountRegister extends Component {

	constructor(props) {
		super();

		this.FB = new FBAuth();
		this.GGL = new GoogleAuth();
		this.TWT = new TwitterAuth();

		this.state = {
			waiting: false,
			fieldValidity: {
				nameInvalid: false,
				tosInvalid: false,
				passwordInvalid: false,
				emailInvalid: false,
			},
			signupComplete: false,
			name: false,
		};
	}

	componentWillMount(props) {
		redirectToPathIf(this.props.dispatch, accountRoute(''), this.props.users.isLoggedIn());

		this.FB.load();
		this.GGL.load();
	}

	componentWillReceiveProps(nProps, nState) {
		redirectToPathIf(nProps.dispatch, accountRoute(''), nProps.users.isLoggedIn());

		if (nProps.users.msg) {
			this.setState({...nState, waiting: false});
		}
	}

	render() {
		return (
			<section className='account-flow'>
				<Helmet title='The FWA - Sign up' />

				<header className='span14 account-flow__head'>
					<div className='span7 span13-mobile push5-desktop'>
						<h1 className='account-flow__head__title'>
							{translate('account/register/header')}
						</h1>
						<h2 className='account-flow__head__title account-flow__head__title--faded'>
							{translate('account/register/subheader')}
						</h2>
					</div>
				</header>

				<ContentBlock title={translate('account/register/aside')}>
					{!this.state.signupComplete && this.renderSignup.bind(this)()}
					{!this.state.signupComplete && this.renderSocialSignup.bind(this)()}
					{this.state.signupComplete && this.renderSignupComplete.bind(this)()}

					<div className='cf'></div>
				</ContentBlock>
			</section>
		);
	}

	renderSignup() {
		return (
			<div className='span4 span6-tablet span100p-mobile account-flow__form'>
				<header className='block-label--relative'>
					{translate('account/register/formtitle')}
				</header>
				<form action='' onSubmit={(e) => this.handleSubmit(e)} noValidate={true}>
					<InputText
						className={'span3 span4-tablet span100p-mobile account-flow__form__input'}
						name='name'
						ref='name'
						type='name'
						required='required'
						placeholder='Full name'
						validate={[
							{rule: VALIDATE_MIN_LENGTH, params: 2},
						]}
					/>

					<span />

					<InputText
						className={'span3 span4-tablet span100p-mobile account-flow__form__input'}
						name='email'
						ref='email'
						type='email'
						required='required'
						placeholder='Email'
						manualValidate={true}
						validate={[
							{ rule: VALIDATE_EMAIL },
						]}
					/>

					<span />

					<InputText
						className={'span3 span4-tablet span100p-mobile account-flow__form__input'}
						name='password'
						ref='password'
						type='password'
						required='required'
						placeholder='Password'
						pattern='^.{6,}$'
						manualValidate={true}
						validate={[
							{ rule: VALIDATE_MIN_LENGTH, params: 6 },
						]}
					/>

					<span />

					<InputText
						className={'span3 span4-tablet span100p-mobile account-flow__form__input'}
						name='password2'
						ref='password2'
						type='password'
						required='required'
						placeholder='Confirm password'
						pattern='^.{6,}$'
						manualValidate={true}
						validate={[
							{ rule: VALIDATE_MIN_LENGTH, params: 6 },
							{ rule: VALIDATE_EQUALS_FIELD, params: () => this.refs.password },
						]}
					/>

					<InputCheckbox
						name='tos'
						ref='tos'
						manualValidate={true}
						validate={[
							{rule: VALIDATE_CHECKED},
						]}
					>
						I am aware of the <Link to={genericRoute(false, 'terms-conditions')} target='_blank'>FWA Terms
					</Link> and <Link to={genericRoute(false, 'privacy-statement')} target='_blank'>Privacy Statement</Link>
					</InputCheckbox>
					<InputSubmit
						name='Sign up'
						waiting={this.state.waiting}
						className={'account-flow__form__submit' + (this.state.waiting ? '' : ' button--go')}
					/>

				</form>
				<div className='account-flow__form__btw'>
					Already a user? <Link to={accountRoute('/login')} className='account-flow__form__btw__link'>Sign in</Link>
				</div>
			</div>
		);
	}

	renderSocialSignup() {
		return (
			<div className='span3 span4-tablet span100p-mobile span account-flow__social'>
				<header className='block-label--relative'>
					{translate('account/register/social')}
				</header>

				<div>
					<button className='button--fb account-flow__social__button' onClick={this.registerFB.bind(this)}>Facebook</button>
				</div>
				<div>
					<button className='button--twt account-flow__social__button' onClick={this.registerTWT.bind(this)}>Twitter</button>
				</div>
				<div>
					<button className='button--ggl account-flow__social__button' onClick={this.registerGGL.bind(this)}>Google</button>
				</div>
			</div>
		);
	}

	renderSignupComplete() {
		return (
			<div className='span4 span6-tablet span100p-mobile account-flow__form'>
				Great, {this.state.name ? this.state.name + ',' : ''} your user account has been created.<br/>
				We've sent an email from where you can activate it.
			</div>
		);
	}

	handleSubmit(e) {
		e.preventDefault();
		let fieldsToValidate = [
			this.refs.name,
			this.refs.email,
			this.refs.password,
			this.refs.password2,
			this.refs.tos,
		];

		if (formIsValid(fieldsToValidate)) {
			this.setState({...this.state, waiting: true});
			this.register.bind(this)(this.refs.name.value(), this.refs.email.value(), this.refs.password.value());
		} else {
			this.setState({...this.state, waiting: false});
		}
	}

	register(name, email, password) {
		let _this = this;
		return axios.post(baseUrl + '/api/account/signup', qs.stringify({
			name: name,
			email: email,
			password: password,
		}))
		.then((response) => {
			this.setState({ ...this.state, signupComplete: true, waiting: false, name: name });
		})
		.catch((response) => {
			this.setState({ ...this.state, signupComplete: false, waiting: false });

			this.props.dispatch(dispatchError(response.data));
		});
	}

	registerFB() {
		this.FB.register(this.props.dispatch);
	}

	registerGGL() {
		this.GGL.register(this.props.dispatch);
	}

	registerTWT() {
		this.TWT.register(this.props.dispatch);
	}
}

export default connect(AccountRegister);



/** WEBPACK FOOTER **
 ** ./frontend/containers/account/register.js
 **/